import React from 'react';
import { Navigate, Outlet, useOutletContext } from 'react-router-dom';
import { useInscriptionState } from '../../../hooks/use-inscription-state.hook';

export const RequireStep2 = () => {
  const ctx = useOutletContext();
  const inscription = useInscriptionState();

  if (!inscription.representant || !inscription.attestation) return <Navigate to="/inscription/etape-2" replace />;

  return <Outlet context={ctx} />;
};